export default "__VITE_ASSET__Cru6U50Z__"